import { useSubproductListener } from '../SubproductListener';
import { useDirectoryListener } from '../useDirectoryListener';

export const useRouteListeners = () => {
  useDirectoryListener();
  useSubproductListener();
};
